import { render, staticRenderFns } from "./coachDetail.vue?vue&type=template&id=65a084b9&scoped=true"
import script from "./coachDetail.vue?vue&type=script&lang=js"
export * from "./coachDetail.vue?vue&type=script&lang=js"
import style0 from "./coachDetail.vue?vue&type=style&index=0&id=65a084b9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a084b9",
  null
  
)

export default component.exports